<template>
  <div class="topNav">
    <div class="topNav_window width1360">
      <div class="topNav_window_left abount">
        <span class="topNav_window_login" @click="backPage"
          ><img src="../assets/image/logo.png" width="100" height="40"
        /></span>
      </div>
      <div class="topNav_window_middle">
        <div class="topNav_window_menu">
          <el-col :span="6" v-for="(item, index) in menuList" :key="index">
            <div class="topNav_window_nav" @click="packWindow(item)">
              <span
                :class="
                  item.value == $route.meta.parents ? 'borderWhiteBottom' : ''
                "
                @mouseover="mouseoverBth('topMneu', item.value)"
                >{{ item.value }}</span
              >
            </div>
          </el-col>
        </div>
      </div>
      <div class="topNav_window_right abount" @click="joinUsList">
        <div
          class="topNav_window_admin"
          @mouseover="mouseoverBth('admin', '')"
          @mouseleave="mouseleaveBth('admin')"
        >
          <span
            :class="
              !BthSwhow
                ? 'topNav_window_admin_text borderWhite'
                : 'topNav_window_admin_text'
            "
            >申请使用</span
          >
          <span
            class="topNav_window_admin_text_blue"
            :class="
              BthSwhow
                ? ' topNav_window_admin_text_blue_state'
                : ' topNav_window_admin_text_blue_end'
            "
            >申请使用<i class="el-icon-right"></i
          ></span>
        </div>
      </div>
    </div>
    <transition name="fade">
      <div
        class="topNav_menu"
        v-if="menushow"
        @mouseleave="mouseleaveBth('menu')"
      >
        <div class="width1360 topNav_menu_menu">
          <div class="topNav_menu_menu_flew topNav_menu_menu_left">
            <div class="relative top20">
              <div class="abount topNav_window_left fontSize20">
                {{ menuListChildrenList.name }}
              </div>
              <div class="topNav_window_middle">
                <ul class="topNav_window_middle_ul">
                  <li
                    v-for="(itemchild, index) in menuListChildrenList.children"
                    :key="index"
                    @mouseover="mouseoverBth('li', itemchild.value)"
                    @click="changeWindow(itemchild)"
                  >
                    <dd>
                      {{ itemchild.value }}
                      <span class="potionClass" v-if="itemchild.show"
                        ><i class="el-icon-arrow-right"></i>
                      </span>
                      <span
                        class="potionClass"
                        v-if="itemchild.key == $route.name"
                        ><i class="el-icon-arrow-right"></i>
                      </span>
                    </dd>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="topNav_menu_menu_flew topNav_menu_menu_right fontSize20">
            <div class="fontSize30">{{ topNavRight }}</div>
            <div class="fontSize15">{{ topNavRightTitle }}</div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "HelloWorld",
  data() {
    return {
      isShowCoin: false,
      menushow: false,
      menuListChildrenList: [],
      topNavRight: "VR全景",
      topNavRightTitle: "提示词",
      BthSwhow: false,
      menuListChildrenTitle: [
        {
          value: "亚场馆全景平台",
          title: "虚实结合, 实现视觉增强"
        },
        {
          value: "飞函邀请函",
          title: "全景数字化营销工具"
        },
        {
          value: "企全景平台",
          title: "连接企业与渠道的全景数字化平台"
        },
        {
          value: "酒店",
          title: "VR+飞函赋能酒店实现商业活动"
        },
        {
          value: "文博",
          title: "VR+飞函构建品牌为核心的数字生态链"
        },
        {
          value: "文体",
          title: "VR+飞函数字化线上端赋能"
        },
        {
          value: "企业",
          title: "VR+ 链接企业与渠道"
        },
        {
          value: "合作伙伴",
          title: "与卓越同行，共创数字未来"
        },
        {
          value: "公司介绍",
          title: "打造数字化平台·助推商业发展"
        }
      ],
      menuListChildren: [
        {
          key: 1,
          name: "公司产品",
          children: [
            {
              key: "VR",
              value: "亚场馆全景平台",
              show: false
            },

            {
              key: "enterprse",
              value: "企全景平台",
              show: false
            },
            {
              key: "FeiHan",
              value: "飞函邀请函",
              show: false
            }
          ]
        },
        {
          key: 2,
          name: "解决方案",
          children: [
            {
              key: "hotel",
              value: "酒店",
              show: false
            },
            {
              key: "wenBo",
              value: "文博",
              show: false
            },
            {
              key: "wenTi",
              value: "文体",
              show: false
            },
            {
              key: "firm",
              value: "企业",
              show: false
            }
          ]
        },
        {
          key: 3,
          name: "资源中心",
          children: [
            {
              key: "Partners",
              value: "合作伙伴",
              show: false
            }
          ]
        },
        {
          key: 4,
          name: "关于我们",
          children: [
            {
              key: "aboutUs",
              value: "公司介绍",
              show: false
            }
          ]
        }
      ],
      menuList: [
        {
          key: 1,
          value: "公司产品",
          show: false
        },
        {
          key: 2,
          value: "解决方案",
          show: false
        },
        {
          key: 3,
          value: "资源中心",
          show: false
        },
        {
          key: 4,
          value: "关于我们",
          show: false
        }
      ],
      routerName: ""
    };
  },
  mounted() {
    this.getArrow();
  },
  methods: {
    joinUsList() {
      this.$emit("joinUsList");
    },

    backPage() {
      this.$router.push("/");
      this.changrTop();
    },
    changrTop() {
      this.$emit("refresh");
    },
    getArrow() {
      if (this.$route.name == "HomePage") {
        this.routerName = "";
      } else {
        this.routerName = this.$route.name;
      }
    },
    packWindow(val) {
      this.menuList.map(i => {
        i.show = false;
      });
      val.show = true;
      this.menuListChildren.map(i => {
        if (i.name == val.value) {
          this.$router.push(i.children[0].key);
          this.changrTop();
        }
      });
    },
    changeWindow(val) {
      this.$router.push(val.key);
      this.changrTop();
    },
    mouseoverBth(tyupe, value) {
      if (tyupe == "admin") {
        this.BthSwhow = true;
      } else if (tyupe == "li") {
        this.menuListChildrenList.children.map(i => {
          i.show = false;
          if (i.value == value) {
            i.show = true;
          }
        });
        this.menuListChildrenTitle.map((i, index) => {
          if (i.value == value) {
            this.topNavRight = i.value;
            this.topNavRightTitle = i.title;
          }
        });
      } else if (tyupe == "topMneu") {
        this.$emit("loadding");
        this.menushow = true;
        this.menuListChildren.map(i => {
          if (i.name == value) {
            console.log(i.name, value);
            i.children.map(j => {
              j.show = false;
            });
            i.show = false;
            this.menuListChildrenList = i;
            this.menuListChildrenTitle.map((i, index) => {
              if (i.value == this.menuListChildrenList.children[0].value) {
                this.topNavRight = i.value;
                this.topNavRightTitle = i.title;
              }
            });
            // this.mouseoverBth(
            //   "li",
            //   this.menuListChildrenList.children[0].value
            // );
          }
        });
      }
    },
    mouseleaveBth(tyupe) {
      if (tyupe == "admin") {
        this.BthSwhow = false;
      } else if (tyupe == "menu") {
        this.menushow = false;
        this.$emit("loaddingOut");
      }
    }
  }
};
</script>
<style scoped scoped lang="less">
.borderWhiteBottom {
  border-bottom: solid 2px #fff !important;
}
.fontSize20 {
  font-size: 40px;
}
.fontSize30 {
  font-size: 35px;
}
.fontSize15 {
  font-size: 25px;
}
.abount {
  position: absolute;
}
.relative {
  position: relative;
}
.topNav_window_left {
  left: 0;
  top: 0;
}
.topNav_window_right {
  right: 0;
  top: 0;
}
.topNav_window_middle {
  margin-left: 200px;
}
.topNav_window_middle_ul {
  padding-bottom: 20px;
  li {
    margin-bottom: 20px;
    cursor: pointer;
    dd {
      width: 30%;
      position: relative;
      .potionClass {
        position: absolute;
        top: 4px;
        right: 0;
      }
    }
  }
}
.lineMiddle {
  float: left;
  width: 1px;
  height: 100%;
  background: #fff;
}
.top20 {
  top: 20px;
}
.topNav_menu_menu_left {
  border-right: solid 1px #8d8b8b;
  min-height: 150px;
}
.topNav_menu_menu_right {
  position: relative;
  top: 20px;
  left: 40px;
}
.topNav_menu {
  width: 100%;
  min-height: 100px;
  border-top: 1px #8d8b8b solid;
  color: #fff;
  .topNav_menu_menu {
    clear: both;
    .topNav_menu_menu_flew {
      display: inline-block;
      width: 49%;
      vertical-align: top;
    }
  }
}
.width1360 {
  max-width: 1360px;
  margin: auto;
  color: #fff;
}

.topNav {
  position: fixed;
  left: 0;
  top: 0;
  backdrop-filter: blur(20px);
  background: rgba(0, 0, 0, 0.2);
  width: 100%;
  z-index: 999999 !important;
  .topNav_window {
    font-size: 14px;
    position: relative;
    .topNav_window_login {
      display: inline-block;
      margin-top: 5px;
      cursor: pointer;
    }
    .topNav_window_menu {
      max-width: 640px;
      height: 52px;
      line-height: 52px;
      .topNav_window_nav {
        span {
          color: #fff;
          border-bottom: #fff;
          position: relative;
          display: inline-block;
          cursor: pointer;
        }
        span:hover::after {
          content: "";
          position: absolute;
          left: 0;
          bottom: 0;
          right: 0;
          width: 100%;
          height: 2px;
          background-color: #fff;
        }
      }
    }

    .topNav_window_admin {
      width: 102px;
      height: 35px;
      line-height: 35px;
      margin-top: 8px;
      font-size: 12px;
      text-align: center;
      position: relative;
      overflow: hidden;
      cursor: pointer;
      .topNav_window_admin_text {
        width: 95%;
        height: 95%;
        border-radius: 30px;
        z-index: 15;
        left: 0;
        top: 0;
        position: absolute;
      }
      .topNav_window_admin_text_blue {
        width: 95%;
        height: 95%;
        background: #5b07f7;
        border-radius: 30px;
        z-index: 16;
        position: absolute;
        top: 1px;
        left: 0;
        margin-left: -100px;
      }
      .topNav_window_admin_text_blue_state {
        animation: move 0.3s;
        animation-fill-mode: forwards;
      }
      .topNav_window_admin_text_blue_end {
        animation: move1 0.3s;
        animation-fill-mode: forwards;
      }
    }
  }
}
.borderWhite {
  border: solid 1px #fff;
}
.fade-enter-active {
  transition: opacity 0.8s;
}
.fade-leave-active {
  transition: opacity 0.2s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active for <=2.1.8 */ {
  opacity: 0;
}
@keyframes move {
  from {
    margin-left: -100px;
  }
  to {
    margin-left: 0;
  }
}
@keyframes move1 {
  from {
    margin-left: 0;
  }
  to {
    margin-left: -100px;
  }
}
</style>



// WEBPACK FOOTER //
// src/public/TopNav.vue